import {Injectable} from '@angular/core';
import {DataService} from '../data.service';
import { HttpClient } from '@angular/common/http';
import {Observable, catchError} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HhgUabCalculatorService extends DataService {

  private baseURI = this.apiUri + '/hhguabcalculator/';

  constructor(http: HttpClient) {
    super(http);
  }

  getKgRate(billKg: number, uabType: string): Observable<any> {
    this.setUri(this.baseURI + billKg + '/' + uabType);
    return this.get().pipe(catchError(this.handleError));
  }

}
